import { render, staticRenderFns } from "./SupervisorCrewPlantCards.vue?vue&type=template&id=1a952667&scoped=true"
import script from "./SupervisorCrewPlantCards.vue?vue&type=script&lang=js"
export * from "./SupervisorCrewPlantCards.vue?vue&type=script&lang=js"
import style0 from "./SupervisorCrewPlantCards.vue?vue&type=style&index=0&id=1a952667&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a952667",
  null
  
)

export default component.exports